var map = {
	"./arrow.png": 451,
	"./carousel/carousel-1-origin.jpg": 452,
	"./carousel/carousel-1.jpg": 453,
	"./carousel/carousel-2-origin.jpg": 454,
	"./carousel/carousel-2.jpg": 455,
	"./carousel/carousel-3-origin.jpg": 456,
	"./carousel/carousel-3.jpg": 457,
	"./gold.png": 458,
	"./icon-1.png": 150,
	"./icon-2.png": 151,
	"./icon-3.png": 152,
	"./icon-4.png": 153,
	"./icon-5.png": 154,
	"./icon-6.png": 155,
	"./icon-7.png": 156,
	"./img-1.png": 115,
	"./img-2.png": 157,
	"./img-3.png": 116,
	"./img-4.png": 158,
	"./joinYyGroup.jpg": 459,
	"./joinYyGroup的副本.jpg": 460,
	"./normal.png": 461,
	"./pop-icon.png": 462,
	"./qrcode.png": 160,
	"./sample.png": 463,
	"./star.png": 464,
	"./text.png": 159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 450;